"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = exports.isBoolean = exports.isString = exports.isNumber = exports.isDate = exports.isError = exports.isObject = exports.isRegexp = exports.isArray = exports.isClient = exports.isStore = void 0;

var _appTypes = _interopRequireDefault(require("./appTypes"));

var isStore = function isStore(appType) {
  return appType === _appTypes["default"].STORE;
};

exports.isStore = isStore;

var isClient = function isClient() {
  return typeof window !== 'undefined';
};

exports.isClient = isClient;

var typeOf = function typeOf(obj) {
  return {}.toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
};

var isArray = function isArray(obj) {
  return typeOf(obj) === 'array';
};

exports.isArray = isArray;

var isRegexp = function isRegexp(obj) {
  return typeOf(obj) === 'regexp';
};

exports.isRegexp = isRegexp;

var isObject = function isObject(obj) {
  return typeOf(obj) === 'object';
};

exports.isObject = isObject;

var isError = function isError(obj) {
  return typeOf(obj) === 'error';
};

exports.isError = isError;

var isDate = function isDate(obj) {
  return typeOf(obj) === 'date';
};

exports.isDate = isDate;

var isNumber = function isNumber(obj) {
  return typeOf(obj) === 'number';
};

exports.isNumber = isNumber;

var isString = function isString(obj) {
  return typeOf(obj) === 'string';
};

exports.isString = isString;

var isBoolean = function isBoolean(obj) {
  return typeOf(obj) === 'boolean';
};

exports.isBoolean = isBoolean;

var isFunction = function isFunction(obj) {
  return typeOf(obj) === 'function';
};

exports.isFunction = isFunction;